import { gql } from '@apollo/client';

export const UPSERT_WORKSPACE_FORM_SUBMISSION_SURVEY = gql`
  mutation upsertWorkspaceFormSubmissionSurvey($input: UpsertWorkspaceFormSubmissionInput!) {
    workspaceFormSubmission: upsertWorkspaceFormSubmissionSurvey(input: $input) {
      id
    }
  }
`;
